<template>
    <!--<PageCover :externalZIndex="1500"/>-->
    <!--<div class="row" id="main-box">-->
        <!--<div class="col-lg-4 col-md-6 col-sm-8" id="alert">-->
            <!--1-->
        <!--</div>-->
    <!--</div>-->
    <!-- The Modal -->
    <div v-if="loadingMood===false" @click="close()" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
            <div class="row" id="main-box">
                <div class="col-lg-4 col-md-6 col-sm-8" id="alert">
                    <div class="alert-content">
                        <div class="alert-header alert-item" v-if="alertContent.waitingMode===false && alertContent.closeButtonShow===true">
                            <span @click="close()" class="close-alert">&times;</span>
                        </div>
                        <div class="alert-image alert-item">
                            <img width="100" height="100" :src="alertContent.imageUrl" alt="">
                        </div>
                        <div class="alert-text alert-item">
                            {{alertContent.message}}
                            <div class="notice">{{alertContent.notice}}</div>
                        </div>
                        <div class="alert-btn alert-item" v-if="alertContent.waitingMode===false">
                            <a  v-if="alertContent.href" :href="alertContent.href" class="btn btn-success btn-block">
                                {{alertContent.buttonText}}
                            </a>
                            <button v-else-if="alertContent.buttonType==='close'" @click="btnClose()" class="btn btn-success btn-block">
                                {{alertContent.buttonText}}
                            </button>
                            <button v-else-if="alertContent.buttonType==='link'" @click="$router.push(alertContent.buttonLink)"  class="btn btn-success btn-block">
                                {{alertContent.buttonText}}
                            </button>
                            <button v-else @click="confirm()"  class="btn btn-success btn-block">
                                {{alertContent.buttonText}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal" v-if="loadingMood">
        <div class="modal-content">
            <!--<div class="loader"></div>-->
            <!--<img width="150" style="position: absolute;top: 0% ; bottom: 0%;margin: auto;left: 0%;right: 0%" src="../assets/loader/Dual-Ring-1s-800px.gif" alt="flag">-->
            <!--<img class="loader" style="position: absolute;top: calc(0% - 80px);bottom: 0%;margin: auto;left: calc(0% - 80px);;right: 0%" src="../assets/loader/loading-image.png" alt="airplane">-->
            <img class="loader" style="position: absolute;top: 0%;bottom: 0%;margin: auto;left: 0% ;right: 0%" src="../assets/loader/dd.png" alt="loader">
        </div>

    </div>
</template>

<script>
    // import PageCover from '@/components/PageCover.vue'
    export default {
        name: "Alert",
        data() {
            return {

            }
        },
        methods: {
            close:function () {
                this.$emit('close');
            },
            btnClose:function(){
                if(this.alertContent.buttonLink!==''){
                    this.$router.push(this.alertContent.buttonLink)
                }
                this.$emit('close');
            },
            confirm:function () {
                this.$emit('confirm');
            }



        },
        props: [
            'alertContent',
            'loadingMood'
        ],
        components: {
            // PageCover
        },
    }
</script>
<style lang="scss" scoped>
    .btn-block{
        z-index: 10000000000;
    }
    .loader {
        /*transform-origin: bottom right;*/
        margin: auto;
       //border: 16px solid #f3f3f3;
        border-radius: 50%;
        //border-top: 16px solid rgb(204, 23, 29);
        width: 200px;
        height: 200px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 1s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    #loader{
        width: 200px;
        height: auto;
        margin: auto;
    }
    .alert-text{
        font-size: 16px!important;
        font-weight: 500!important;
        font-stretch: normal!important;
        font-style: normal!important;
        line-height: normal!important;
        letter-spacing: normal!important;
        text-align: center!important;
        color: #162336!important;
    }
    .alert-item{
        padding: 5px;
        width: 100%;
        height: auto;
        margin: 10px 0;
        line-height: 20px;
        color: white;
        font-weight: bold;
        font-size: 2em;
        text-align: center;
    }
    #alert{
        z-index: 50;
        border-radius: 10px;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        margin: auto;
        min-height: 200px;
        box-shadow:  0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    }
    .alert-content{
        width: 100%;
        height: auto;
    }


    /* The Modal (background) */
    .modal {
        display: flex; /* Hidden by default */
        position: fixed; /* Stay in place */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
        z-index: 100000000000;
    }

    /* Modal Content */
    .modal-content {
        position: relative;
        background-color:unset!important; ;
        margin: auto;
        padding: 0;
        border: unset!important;
        width: 80%;
        box-shadow:unset!important;
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s;
        z-index: 500000;

    }

    /* Add Animation */
    @-webkit-keyframes animatetop {
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    }

    @keyframes animatetop {
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    }

    /* The Close Button */
    .close-alert {
        color: #262626;
        font-size: 28px;
        font-weight: bold;

    }

    .close-alert:hover,
    .close-alert:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .alert-header {
        top: 5px;
        left: 15px;
        position: absolute;
        width: auto;
        text-align: left;
        height: 50px;
    }

    .modal-body {padding: 2px 16px;}



    button:hover{
        background-color: #fe7063;
        border: none;
    }

    button{
        max-width: 280px;
        width: 95%;
        height: 50px;
        border-radius: 5px;
        background-color: #162336;
        padding: 11px 41px;
        font-size: 16px;
        margin: auto;
    }

</style>